import CatalogListPage from '../modules/catalogs/pages/CatalogListPage/CatalogListPage';
import CatalogProductsScreen from '../modules/catalogs/products/CatalogScreen/CatalogProductsScreen';
import OrderListPage from '../modules/orders/pages/OrderListPage/OrderListPage';
import OrderObjectPage from '../modules/orders/pages/OrderObjectPage/OrderObjectPage';
import PATHS from './routes.const';
import { TeceoRoute } from './routes.types';

export const getOfflineHomeRoutes = (): TeceoRoute[] => [
  {
    exact: true,
    name: 'orders',
    path: PATHS.offline.orders.path,
    render: (props) => <OrderListPage {...props} isOfflineMode />,
  },
  {
    name: 'orders',
    path: PATHS.offline.orders.editForm.path,
    render: ({ history }) => (
      <OrderObjectPage
        isOfflineMode
        onSuccessSyncOfflineOrder={() => history.push(PATHS.offline.orders.path)}
      />
    ),
  },
  {
    name: 'orders',
    path: PATHS.offline.orders.finished.path,
    render: ({ history }) => (
      <OrderObjectPage
        isOfflineMode
        onSuccessSyncOfflineOrder={() => history.push(PATHS.offline.orders.path)}
      />
    ),
  },
  {
    exact: true,
    name: 'catalogs',
    path: PATHS.offline.catalogs.path,
    render: (props) => <CatalogListPage {...props} isOfflineMode />,
  },
  {
    name: 'catalogs',
    path: PATHS.offline.catalogs.products.path,
    render: (props) => (
      <CatalogProductsScreen {...props} key={props.match.params.id} isOfflineMode />
    ),
  },
];
